export const DEFAULT_ACTION = "app/CasesDetails/DEFAULT_ACTION";
export const CASEUPDATE = "app/CasesDetails/CASEUPDATE";
export const SELECTCASE = "app/CasesDetails/SELECTCASE";

